/* ---------- Hero: the headline figure beside the map of where the clients are ---------- */
.hero {
  /* Same overlap as the home hero: cancel the flow space the sticky header reserves. */
  margin-top: calc(-1 * (var(--header-h) + 2 * var(--header-margin)));
  padding-block: calc(var(--header-h) + 2 * var(--header-margin) + var(--sp-12)) var(--sp-16);
  background: var(--surface-alt);
}
.heroGrid {
  display: grid;
  gap: var(--sp-12);
  align-items: center;
}
.heroText > * {
  max-width: 36rem;
}
.heroTitle {
  /* Room under the breadcrumb, which the dropped eyebrow label used to provide. */
  margin-top: var(--sp-6);
  font-size: clamp(2.4rem, 3.4vw + 1rem, 4.25rem);
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
}
.heroLead {
  margin-top: var(--sp-5);
  font-size: var(--fs-lg);
  color: var(--text);
}
.figures {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--sp-3) var(--sp-8);
  margin-top: var(--sp-8);
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border-strong);
  color: var(--text-muted);
}
.figures strong {
  margin-right: 0.3em;
  font-family: var(--font-display);
  font-size: var(--fs-2xl);
  font-weight: 700;
  letter-spacing: var(--tracking-heading);
  color: var(--text-strong);
}
@media (min-width: 64rem) {
  .heroGrid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
    gap: var(--sp-16);
  }
}

/* ---------- The logos: open rows, each mark over its name ---------- */
.logos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 10.5rem), 1fr));
  gap: var(--sp-10) var(--sp-8);
}
.client {
  display: grid;
  justify-items: center;
  align-content: start;
  gap: var(--sp-3);
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border);
  text-align: center;
}
.mark {
  display: grid;
  place-items: center;
  height: 4rem;
}
.logo {
  height: 3.5rem;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  opacity: 0.85;
}
/* The marks are white for dark sections; a light section turns them black. */
:global([data-surface="light"]) .logo {
  filter: invert(1);
  opacity: 0.8;
}
.name {
  font-size: var(--fs-sm);
  color: var(--text-muted);
  text-wrap: balance;
}
@media (max-width: 47.99rem) {
  .logos {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--sp-8) var(--sp-5);
  }
}
